var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticStyle:{"border-radius":"5px"},attrs:{"color":_vm.statuscolor(_vm.statusId),"dark":"","small":""}},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }